import React from "react";
import "./HomeFlags.css";
import HomeFlagCard from "./HomeFlagCard";
import bahrain from "../../../vid_img/Countries_Flag/Baharain.png";
import malaysia from "../../../vid_img/Countries_Flag/Malaysia.png";
import qatar from "../../../vid_img/Countries_Flag/Qatar.png";
import saudi from "../../../vid_img/Countries_Flag/Saudi Arabia.png";
import uae from "../../../vid_img/Countries_Flag/UAE.png";
import kuwait from "../../../vid_img/Countries_Flag/Kuwait.png";

const HomeFlagsMain = () => {
  return (
    <div className="homeFlagMainContainer">
      <HomeFlagCard
        flag={malaysia}
        name="MALAYSIA"
        alt="Malaysia"
        link="/mea-attestation-apostille-services"
      />
      <HomeFlagCard
        flag={uae}
        name="UAE"
        alt="uaeEmbassy"
        link="/uae-embassy-attestation-bangalore"
      />

      <HomeFlagCard
        flag={qatar}
        name="QATAR"
        alt="qatarEmbassy"
        link="/qatar-embassy-attestation-bangalore"
      />
      <HomeFlagCard
        flag={kuwait}
        name="KUWAIT"
        alt="kuwaitEmbassy"
        link="/kuwait-embassy-attestation-bangalore"
      />
      <HomeFlagCard
        flag={bahrain}
        name="BAHRAIN"
        alt="bahrainEmbassy"
        link="/bahrain-embassy-attestation-bangalore"
      />

      <HomeFlagCard
        flag={saudi}
        name="SAUDI"
        alt="saudiEmbassy"
        link="/saudi-embassy-attestation-bangalore"
      />
    </div>
  );
};

export default HomeFlagsMain;
